function AccountProfilePage() {
  return <div />;
}

export default AccountProfilePage;
